import { PAYGInfoModal } from "./components/PAYGInfoModal";

import { Text } from "@otta/design";

const videos = [
  {
    videoUrl: "https://vimeo.com/1101495426",
    children: (
      <Text>
        When thinking about posting your roles, put yourself in the candidate's
        position, would you apply to work at your company? To make this a yes,
        watch the video for our golden rules, based on a wealth of candidate
        data and research we've done.
      </Text>
    ),
    heading: "Optimise your job for the best quality inbound applications",
  },
  {
    videoUrl: "https://vimeo.com/1101496345",
    children: (
      <>
        <Text>
          Due to our curated candidate marketplace, we put a lot of emphasis on
          ensuring your business and your role stands out to top talent. If your
          role is not receiving enough applications, watch this video for our
          top tips.
        </Text>
        <Text>
          Want more tips? Consider upgrading your plan to access Sourcing and
          Customer Success insights and tailored services, particularly if the
          role is harder to fill, or a very senior role.
        </Text>
      </>
    ),
    heading: "Top tips for success",
  },
  {
    videoUrl: "https://vimeo.com/1101496202",
    children: (
      <Text>
        You can find all your subscription details, invoices and billing
        information on your settings page. Click on the tab on the left hand
        side to access it.
      </Text>
    ),
    heading: "Your Startup Essential plan",
  },
];

export function PAYGSubscriptionCreation(): React.ReactElement | null {
  return (
    <PAYGInfoModal
      videos={videos}
      name="essential-monthly-payg-subscription-creation"
    />
  );
}
